import type { Comment } from "@/react/types/Comment";

export interface CommentPermissions {
  canBookmark: boolean;
  canDestroy: boolean;
  canEdit: boolean;
  canModerate: boolean;
  canReport: boolean;
}

export const useCommentPermissions = (comment: Comment): CommentPermissions => {
  const { policies } = comment;

  return {
    canBookmark: policies.can_bookmark,
    canDestroy: policies.can_destroy,
    canEdit: policies.can_edit,
    canModerate: policies.can_manage,
    canReport: policies.can_report,
  };
};
